import { Dropdown } from '@postidigital/posti-components'
import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import Localization from '../../locales'
import { infoStore, StoreContext } from '../../store'
import { ContentSection } from '../layout'
import { ResponsiveHeadline } from '../typography/ResponsiveHeadline'

const options: any = {
  fi: [
    { value: 'fi', label: 'Suomi' },
    { value: 'sv', label: 'Ruotsi' },
    { value: 'en', label: 'Englanti' },
  ],
  sv: [
    { value: 'fi', label: 'Finska' },
    { value: 'sv', label: 'Svenska' },
    { value: 'en', label: 'Engelska' },
  ],
  en: [
    { value: 'fi', label: 'Finnish' },
    { value: 'sv', label: 'Swedish' },
    { value: 'en', label: 'English' },
  ],
}

const PreferredLanguageDropDownComponent: React.FC = () => {
  const { t } = useTranslation()

  const currentLanguage = Localization.CurrentLocale
  const { userStore } = useContext(StoreContext)

  // TODO this should be fetched from API https://postinext.atlassian.net/browse/OAS-1697
  const initialSelection = options[currentLanguage].find((p: any) => {
    return p.value === userStore.identities.consumerIdentity.communicationLanguage
  })

  const onChange = (p: any) => {
    userStore.setLanguage(p.value)
  }

  return (
    <div style={{ maxWidth: '430px' }}>
      <ContentSection top={false} gap="md">
        <ResponsiveHeadline>{t('detailsView.comLang')}</ResponsiveHeadline>
        <Dropdown
          lightBackground
          inputId="languageDropdown"
          options={options[currentLanguage]}
          label={t(`detailsView.language`)}
          onChange={onChange}
          defaultValue={initialSelection}
          isDisabled={infoStore.isPartialConsumer}
        />
      </ContentSection>
    </div>
  )
}

export const PreferredLanguageDropDown = observer(PreferredLanguageDropDownComponent)
